<template>
  <div class="home">
    <HeaderBar></HeaderBar>
    <div class="banner">
      <b-carousel
          id="carousel-1"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="100%"
      >
        <b-carousel-slide
            v-for="item in bannerList"
            :key="item.id"
            :img-src="item.url"
        ></b-carousel-slide>
      </b-carousel>
    </div>
    <section class="company-introduce animate-box fadeInUp animated">
      <div class="container">
        <div class="row">
          <div class="col-lg-5">
            <div class="img-responsive">
              <img src="../assets/index1.jpg"/>
            </div>
          </div>
          <div class="col-lg-7 content">
            <h2 class="text-center title">公司简介<br/>ABOUT US</h2>
            <p class="text-center">
              福州鑫微创网络科技有限公司作为一家聚焦“互联网＋”<br/>
              与数字化转型的创新型科技企业，始终致力于将最新的网<br/>
              络技术、移动应用开发和数据智能技术融入产品设计与系统建设。<br/>
              公司核心产品 “回收宝” 面向再生资源回收行业，<br/>
              旨在构建数智再生资源回收体系，通过回收点管理、<br/>
              资源追溯、数据分析以及平台协同等功能，实现政府、回<br/>
              收企业、社区与加工端的高效连接。
            </p>
            <div class="text-center">
              <!-- <b-button variant="success">立即咨询</b-button> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="company-lightspot">
      <div class="gary">
        <div class="container">
          <div class="row">
            <div class="col-lg-2 lightspot-item">
              <div class="hg-45"></div>
              <img src="../assets/ico1.png"/>
              <div class="hg-10"></div>
              <div class="font-18">开创性模式</div>
            </div>
            <div class="col-lg-2 lightspot-item">
              <div class="hg-45"></div>
              <img src="../assets/ico2.png"/>
              <div class="hg-10"></div>
              <div class="font-18">数字化应用</div>
            </div>
            <div class="col-lg-2 lightspot-item">
              <div class="hg-45"></div>
              <img src="../assets/ico3.png"/>
              <div class="hg-10"></div>
              <div class="font-18">智慧监控</div>
            </div>
            <div class="col-lg-2 lightspot-item">
              <div class="hg-45"></div>
              <img src="../assets/ico4.png"/>
              <div class="hg-10"></div>
              <div class="font-18">一体化循环</div>
            </div>
            <div class="col-lg-2 lightspot-item">
              <div class="hg-45"></div>
              <img src="../assets/ico5.png"/>
              <div class="hg-10"></div>
              <div class="font-18">智能渊源</div>
            </div>
            <div class="col-lg-2 lightspot-item">
              <div class="hg-45"></div>
              <img src="../assets/ico6.png"/>
              <div class="hg-10"></div>
              <div class="font-18">流程可视</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="company-business">
      <div class="container">
        <h2 class="business-title">业务类型<br/>BUSINESS TYPE</h2>
        <div class="row">
          <div class="col-lg-3">
            <div class="business-box">
              <div class="business-img">
                <img src="../assets/business1.jpg" width="100%"/>
                <div class="shadow"></div>
              </div>
              <div class="business-content">
                <div class="title">管道疏通业务</div>
                <div class="business-btn">
                  <router-link :to="{ path: 'business', query: { id: 24 } }"
                  >
<!--                    <b-button variant="outline-dark"-->
<!--                    >查看详情-->
<!--                    </b-button-->
<!--                    >-->
                  </router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="business-box">
              <div class="business-img">
                <img src="../assets/business2.jpg" width="100%"/>
                <div class="shadow"></div>
              </div>
              <div class="business-content">
                <div class="title">
                 回收宝
                </div>
                <div class="business-btn">
                  <router-link :to="{ path: 'business', query: { id: 25 } }"
                  >
<!--                    <b-button variant="outline-dark"-->
<!--                    >查看详情-->
<!--                    </b-button-->
<!--                    >-->
                  </router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="business-box">
              <div class="business-img">
                <img src="../assets/business3.jpg" width="100%"/>
                <div class="shadow"></div>
              </div>
              <div class="business-content">
                <div class="title">社区经济业务</div>
                <div class="business-btn">
                  <router-link :to="{ path: 'business', query: { id: 26 } }"
                  >
<!--                    <b-button variant="outline-dark"-->
<!--                    >查看详情-->
<!--                    </b-button-->
<!--                    >-->
                  </router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="business-box">
              <div class="business-img">
                <img src="../assets/business4.jpg" width="100%"/>
                <div class="shadow"></div>
              </div>
              <div class="business-content">
                <div class="title">大数据应用开发运营业务</div>
                <div class="business-btn">
                  <router-link :to="{ path: 'business', query: { id: 27 } }"
                  >
<!--                    <b-button variant="outline-dark"-->
<!--                    >查看详情-->
<!--                    </b-button-->
<!--                    >-->
                  </router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="company-servive">
      <div class="gray">
        <div class="container">
          <div class="hg-80"></div>
          <h2 class="title">目标&战略理念<br/>SERVIVE SURPOSE</h2>
          <p class="content">
            秉承“有限资源、无限再生”的理念，<br/>
            依托系统强大的再生资源回收网络优势，<br/>
            以成为资源再生的引领者和生态环境的守护者为目标，<br/>
            确立了<span class="dot">“网络化布局、基地化运营、综合化服务”</span
          >的核心经营战略。
          </p>
        </div>
      </div>
    </section>
    <section class="company-strengths">
      <div class="container">
        <h2 class="title">我们的优势<br/>OUR STRENGTHS</h2>
        <div class="row">
          <div class="col-lg-4 text-center">
            <img src="../assets/our1.png"/>
            <div class="hg-20"></div>
            <span class="text">精细化城市智慧管理</span>
          </div>
          <div class="col-lg-4 text-center">
            <img src="../assets/our2.png"/>
            <div class="hg-20"></div>
            <span class="text">赋予城市大数据应用</span>
          </div>
          <div class="col-lg-4 text-center">
            <img src="../assets/our3.png"/>
            <div class="hg-20"></div>
            <span class="text">全流程零排放、无害化、资源化</span>
          </div>
          <div class="hg-50"></div>
          <div class="col-lg-4 text-center">
            <img src="../assets/our4.png"/>
            <div class="hg-20"></div>
            <span class="text">改变行业落后原始现状</span>
          </div>
          <div class="col-lg-4 text-center">
            <img src="../assets/our5.png"/>
            <div class="hg-20"></div>
            <span class="text">助力新农村建设，助推乡村振兴</span>
          </div>
          <div class="col-lg-4 text-center">
            <img src="../assets/our6.png"/>
            <div class="hg-20"></div>
            <span class="text">绿水青山就是金山银山</span>
          </div>
        </div>
      </div>
    </section>
    <section class="company-team">
      <div class="gray">
        <div class="container">
          <div class="hg-80"></div>
          <h2 class="title">团队风采<br/>TEAM STYLE</h2>
          <div class="row">
            <div class="col-lg-3">
              <div class="row">
                <div class="col-lg-12">
                  <div class="t1"></div>
                </div>
                <div class="hg-30"></div>
                <div class="col-lg-12">
                  <div class="t2"></div>
                </div>
              </div>
            </div>
            <div class="col-lg-9">
              <div class="row">
                <div class="col-lg-12">
                  <div class="t3"></div>
                </div>
                <div class="hg-30"></div>
                <div class="col-lg-7">
                  <div class="t4"></div>
                </div>
                <div class="col-lg-5">
                  <div class="t5"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="company-contact">
      <div class="hg-80"></div>
      <h2 class="title">联系我们<br/>CONTACT US</h2>
      <el-amap
          ref="amapDemo"
          vid="amapDemo"
          :zoom="20"
          :center="center"
          class="map-view"
          :amap-manager="amapManager"
          :events="mapEvents"
          :zoomEnable="false"
      >
        <el-amap-marker
            :position="center"
            title="福建新硕环保有限公司(0591-78520930)地址：福州市鼓楼区中庚青年广场15楼"
        ></el-amap-marker>
      </el-amap>
    </section>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
import HeaderBar from '@/components/header-bar';
import FooterBar from '@/components/footer-bar';
import {AMapManager} from 'vue-amap';

let amapManager = new AMapManager();
export default {
  name: 'index',
  components: {
    HeaderBar,
    FooterBar,
  },
  data() {
    return {
      amapManager,
      bannerList: [
        {
          id: 1,
          url:
              'https://s3.su.bcebos.com/recycle-minggong/2025/10/27/55ed42f24cef4fd9a44ba438157b8d14.jpg',
        },
        {
          id: 3,
          url:
              'https://s3.su.bcebos.com/recycle-minggong/2025/10/27/92bd7646a5bb428ab671af79effe02ce.jpg',
        },
      ],
      center: [119.353453, 26.083976],
      mapEvents: {
        init(o) {
        },
      },
    };
  },
  computed: {
    swiperOption() {
      if (window.innerWidth < 991) {
        return {slidesPerView: 1, spaceBetween: 0};
      } else {
        return {slidesPerView: 3, spaceBetween: 30};
      }
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss">
.home {
  .company-introduce {
    padding: 6rem 0;

    .img-responsive {
      position: relative;

      img {
        margin: 3rem 0 0 3rem;
        width: 82%;
      }

      &::after {
        z-index: -1;
        position: absolute;
        left: 0;
        top: 0;
        height: 330px;
        width: 330px;
        content: ' ';
        border: 5px solid #007bff;
      }
    }

    .content {
      color: #333;
      font-size: 1.1rem;

      .title {
        font-size: 1.8rem;
        margin-bottom: 2.6rem;
        position: relative;

        &::before {
          border-left: 4px solid #007bff;
          border-top: 4px solid #007bff;
          border-right: 4px solid #007bff;
          position: absolute;
          left: 50%;
          top: -1.5rem;
          content: '';
          width: 50px;
          height: 16px;
          margin-left: -25px;
        }

        &::after {
          border-bottom: 4px solid #007bff;
          position: absolute;
          left: 50%;
          bottom: -0.8rem;
          content: '';
          width: 50px;
          margin-left: -25px;
        }
      }

      p {
        font-weight: 600;
        line-height: 2rem;
      }
    }
  }

  .company-lightspot {
    height: 240px;
    width: 100%;
    background: url(../assets/index2.png) no-repeat;
    background-size: 100% auto;

    .gary {
      background: rgba(0, 0, 0, 0.4);
      width: 100%;
      height: 100%;
    }

    .lightspot-item {
      text-align: center;
      color: #fff;

      img {
        padding: 10px;
        width: 120px;
        height: 120px;
      }
    }
  }

  .company-business {
    padding: 5rem 0;
    position: relative;

    .business-title {
      text-align: center;
      font-size: 1.8rem;
      margin-bottom: 5rem;
      position: relative;

      &::before {
        border-left: 4px solid #007bff;
        border-top: 4px solid #007bff;
        border-right: 4px solid #007bff;
        position: absolute;
        left: 50%;
        top: -1.5rem;
        content: '';
        width: 50px;
        height: 16px;
        margin-left: -25px;
      }

      &::after {
        border-bottom: 4px solid #007bff;
        position: absolute;
        left: 50%;
        bottom: -0.8rem;
        content: '';
        width: 50px;
        margin-left: -25px;
      }
    }

    .business-box {
      margin-bottom: 2rem;

      .business-img {
        width: 100%;
        height: 140px;
        overflow: hidden;
        position: relative;
        text-align: center;

        img {
          transition: all 0.8s ease;
        }

        .shadow {
          background: rgba(0, 0, 0, 0.7);
          display: none;
          position: absolute;
          height: 100%;
          width: 100%;
          left: 0;
          top: 0;
        }
      }

      .business-content {
        position: relative;
        height: 10rem;
        transition: all 0.2s ease;
        background: #fff;
        color: #85919d;
        padding: 1rem;
        font-size: 0.8rem;
        border-left: 1px solid #e7e7e7;
        border-right: 1px solid #e7e7e7;
        border-bottom: 1px solid #e7e7e7;

        .title {
          text-align: center;
          transition: all 0.2s ease;
          color: #333;
          margin-bottom: 1rem;
          font-size: 1.2rem;
        }

        .business-btn {
          position: absolute;
          left: 50%;
          bottom: 0.8rem;
          margin-left: -45px;
        }
      }

      &:hover {
        .business-img img {
          transform: scale(1.2);
        }

        .shadow {
          display: block;
        }

        .business-content {
          background: #007bff;
          color: #fff;

          .title {
            color: #fff;
          }
        }
      }
    }
  }

  .company-servive {
    height: 430px;
    width: 100%;
    background: url(../assets/index3.png) center center no-repeat;
    background-size: 100% auto;

    .gray {
      background: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;

      .title {
        text-align: center;
        font-size: 1.8rem;
        margin-bottom: 4rem;
        position: relative;
        color: #fff;

        &::before {
          border-left: 4px solid #007bff;
          border-top: 4px solid #007bff;
          border-right: 4px solid #007bff;
          position: absolute;
          left: 50%;
          top: -1.5rem;
          content: '';
          width: 50px;
          height: 16px;
          margin-left: -25px;
        }

        &::after {
          border-bottom: 4px solid #007bff;
          position: absolute;
          left: 50%;
          bottom: -0.8rem;
          content: '';
          width: 50px;
          margin-left: -25px;
        }
      }

      .content {
        color: #fff;
        text-align: center;
        line-height: 2.4rem;
        font-size: 1.2rem;

        .dot {
          font-weight: 600;
          font-size: 1.6rem;
          color: #007bff;
          padding: 0 1rem;
        }
      }
    }
  }

  .company-strengths {
    background: #fff;
    padding: 5rem;

    .title {
      text-align: center;
      font-size: 1.8rem;
      margin-bottom: 4rem;
      position: relative;

      &::before {
        border-left: 4px solid #007bff;
        border-top: 4px solid #007bff;
        border-right: 4px solid #007bff;
        position: absolute;
        left: 50%;
        top: -1.5rem;
        content: '';
        width: 50px;
        height: 16px;
        margin-left: -25px;
      }

      &::after {
        border-bottom: 4px solid #007bff;
        position: absolute;
        left: 50%;
        bottom: -0.8rem;
        content: '';
        width: 50px;
        margin-left: -25px;
      }
    }

    .text {
      font-size: 1.2rem;
    }
  }

  .company-team {
    width: 100%;
    height: 830px;
    background: url(../assets/team-bg.jpg) center center no-repeat;
    background-size: 100% auto;

    .gray {
      background: rgba(0, 0, 0, 0.7);
      width: 100%;
      height: 100%;

      .title {
        text-align: center;
        font-size: 1.8rem;
        margin-bottom: 4rem;
        position: relative;
        color: #fff;

        &::before {
          border-left: 4px solid #007bff;
          border-top: 4px solid #007bff;
          border-right: 4px solid #007bff;
          position: absolute;
          left: 50%;
          top: -1.5rem;
          content: '';
          width: 50px;
          height: 16px;
          margin-left: -25px;
        }

        &::after {
          border-bottom: 4px solid #007bff;
          position: absolute;
          left: 50%;
          bottom: -0.8rem;
          content: '';
          width: 50px;
          margin-left: -25px;
        }
      }

      .t1 {
        background: url(../assets/t5.jpg) center center no-repeat;
        background-size: auto 100%;
        height: 305px;
        width: 100%;
      }

      .t2 {
        background: url(../assets/t2.jpg) center center no-repeat;
        background-size: 100% auto;
        height: 200px;
        width: 100%;
      }

      .t3 {
        background: url(../assets/t1.jpg) center center no-repeat;
        background-size: 100% auto;
        height: 250px;
        width: 100%;
      }

      .t4 {
        background: url(../assets/t4.jpg) center center no-repeat;
        background-size: 100% auto;
        height: 250px;
        width: 100%;
      }

      .t5 {
        background: url(../assets/t3.jpg) center center no-repeat;
        background-size: 100% auto;
        height: 250px;
        width: 100%;
      }
    }
  }

  .company-contact {
    background: #fff;
    overflow: hidden;

    .title {
      text-align: center;
      font-size: 1.8rem;
      margin-bottom: 4rem;
      position: relative;

      &::before {
        border-left: 4px solid #007bff;
        border-top: 4px solid #007bff;
        border-right: 4px solid #007bff;
        position: absolute;
        left: 50%;
        top: -1.5rem;
        content: '';
        width: 50px;
        height: 16px;
        margin-left: -25px;
      }

      &::after {
        border-bottom: 4px solid #007bff;
        position: absolute;
        left: 50%;
        bottom: -0.8rem;
        content: '';
        width: 50px;
        margin-left: -25px;
      }
    }

    .map-view {
      height: 500px;
    }
  }
}
</style>
